import {
  amplitudeKeyInternal,
  amplitudeKeyOldInternal,
  amplitudeKeyOldProd,
  amplitudeKeyProd,
  appTimestamp,
  appVersion,
  autodeskApiUrl,
  commitId,
  commitUrl,
  intercomAppIdProd,
  jiraTicketId,
  jiraTicketUrl,
  localizeKey,
  muiProKey,
  procoreApiUrlProduction,
  pullRequestId,
  pullRequestUrl,
  sentryDSNKey,
} from "@src/runtime-config-base";
import { RuntimeConfig } from "@src/runtime-config-types";

export const runtimeConfig: RuntimeConfig = {
  environment: "production",
  appRegion: "com",
  appEnv: "com-production",
  urls: {
    apiBaseUrl: "https://core.api.holobuilder.com",
    sphereViewerUrl: "https://viewer.holobuilder.com",
    dashboard20Api: "https://sphere.holobuilder.com/api",
    hbWebEditorUrl: "https://app.holobuilder.com",
    progressApiUrl: "https://progress.api.holobuilder.com",
    sphereEntryPageUrl: "https://entry.holobuilder.com",
    adminPanelUrl: "https://admin.holobuilder.com",
    cookieManagerUrl:
      "https://cookies.holobuilder.com/cookie-manager/manager/latest",
    powerBIBaseUrl: "https://hb-powerbi-func-com.azurewebsites.net",
    projectApiUrl: "https://v2.project.api.holobuilder.com",
    hbDashboardUrl: "https://dashboard.holobuilder.com",
    uploadFrontDoorUrl: "https://uploads.holobuilder.com",
    uploadStorageUrl: "https://holobuildercom.blob.core.windows.net",
    activityApiUrl: "https://activity.api.holobuilder.com",
  },
  features: {
    muiProKey,
    localizeKey,
    sentryDSNKey,
    auth0: {
      domain: "login.eu.farosphere.com",
      clientId: "VIgbt2dDKTFhsj2as6umqhKylJ01psTg",
    },
    amplitudeKeyInternal,
    amplitudeKeyProd,
    amplitudeKeyOldInternal,
    amplitudeKeyOldProd,
    intercomAppId: intercomAppIdProd,
  },
  integrations: {
    procoreApiUrl: procoreApiUrlProduction,
    autodeskApiUrl,
  },
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  mailSupportAddress: "support@holobuilder.com",
  isNumberedEnv: false,
  numberedEnv: null,
};
